import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20background%20with%20encrypted%20chat%20interface%20and%20spotlight%20silhouettes%2C%20deep%20crimson%20red%20and%20black%20tones%2C%20dramatic%20theatrical%20lighting%2C%20digital%20secrets%20and%20leaks%20concept%2C%20cinematic%20noir%20aesthetic%2C%20high%20contrast%2C%20minimal%20composition%2C%20clean%20dark%20gradient%20edges&width=1920&height=900&seq=hero-bg-911&orientation=landscape"
          alt="911爆料网 - 第一时间放出猛料"
          title="911爆料网 吃瓜黑料 网红爆料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-24 md:py-32">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 text-xs font-semibold bg-primary-500/20 text-primary-300 border border-primary-500/30 rounded-full mb-6">
              911爆料网 · 全网最快吃瓜平台
            </span>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-background-50 leading-[1.1] tracking-tight">
              网红反差博主私下
              <br />
              <span className="text-primary-400">明星聊天记录</span>
              <br />
              猛料泄露
            </h1>
            <p className="mt-6 max-w-xl text-base md:text-lg text-background-50/70 leading-relaxed">
              911爆料网App与下载通道，承接全网吃瓜黑料内容。网红反差视频、博主私下爆料、明星聊天记录泄露，第一时间放出猛料。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/wanghong-heiliao"
                className="px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap text-center"
              >
                立即吃瓜 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 text-sm font-semibold border border-background-50/25 text-background-50 rounded-full hover:bg-background-50/10 transition-all cursor-pointer whitespace-nowrap text-center"
              >
                下载APP <i className="ri-download-line ml-1"></i>
              </Link>
            </div>
          </div>

          <div className="flex-1 w-full flex flex-col gap-4">
            <Link
              to="/article/wanghong-fancha-baoliao-001"
              className="group block p-5 bg-background-50/8 backdrop-blur-sm border border-background-50/10 rounded-xl hover:bg-background-50/12 transition-all cursor-pointer"
            >
              <span className="text-[11px] font-medium text-primary-400">最新猛料</span>
              <h3 className="mt-1 text-base font-bold text-background-50 group-hover:text-primary-300 transition-colors leading-snug">
                某千万粉丝网红私下反差视频流出，豪宅聚会画面曝光
              </h3>
              <div className="flex items-center gap-3 mt-3 text-xs text-background-50/50">
                <span className="flex items-center gap-1"><i className="ri-fire-line text-primary-400"></i>128.5w热度</span>
                <span>2026-07-06</span>
              </div>
            </Link>
            <Link
              to="/article/mingxing-liaotian-jilu-xielou-002"
              className="group block p-5 bg-background-50/8 backdrop-blur-sm border border-background-50/10 rounded-xl hover:bg-background-50/12 transition-all cursor-pointer"
            >
              <span className="text-[11px] font-medium text-accent-400">爆炸新闻</span>
              <h3 className="mt-1 text-base font-bold text-background-50 group-hover:text-primary-300 transition-colors leading-snug">
                某顶流男星暧昧聊天记录遭泄露，对方竟是已婚女演员
              </h3>
              <div className="flex items-center gap-3 mt-3 text-xs text-background-50/50">
                <span className="flex items-center gap-1"><i className="ri-fire-line text-primary-400"></i>256.3w热度</span>
                <span>2026-07-05</span>
              </div>
            </Link>
            <Link
              to="/article/bozhu-baoliao-jingji-gongsi-003"
              className="group block p-5 bg-background-50/8 backdrop-blur-sm border border-background-50/10 rounded-xl hover:bg-background-50/12 transition-all cursor-pointer"
            >
              <span className="text-[11px] font-medium text-accent-400">独家爆料</span>
              <h3 className="mt-1 text-base font-bold text-background-50 group-hover:text-primary-300 transition-colors leading-snug">
                曝某MCN机构强迫旗下博主陪酒应酬，不听话就雪藏封杀
              </h3>
              <div className="flex items-center gap-3 mt-3 text-xs text-background-50/50">
                <span className="flex items-center gap-1"><i className="ri-fire-line text-primary-400"></i>89.7w热度</span>
                <span>2026-07-04</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}